import { LabelRequestDummy, LabelRequestGapLabelMetaDummy } from '@kinderlabs-pos/shared-data-type';
import { PosElectronStoreState, PrintReceiptState, StoreInfoState } from '@kinderlabs-pos/state';
import {
	Box,
	Button,
	FormControl,
	FormControlLabel,
	FormLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	Stack,
} from '@mui/material';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { SettingMenuItem } from '../common';

export const LabelPage = () => {
	const [selected, setSelected] = useState(1);
	const localSettings = PosElectronStoreState.usePosMainPageLocalSettings().data;
	const saveLocalSettingsMutation = PosElectronStoreState.useSavePosLocalSettings();

	const selectLP1 = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (localSettings)
			saveLocalSettingsMutation.mutate({
				...localSettings,
				useNewDesignOnLabelPrinter1: event.target.value === 'new',
				useGapLabelOnLabelPrinter1: event.target.value === 'gap',
			});
	};
	const selectLP2 = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (localSettings)
			saveLocalSettingsMutation.mutate({
				...localSettings,
				useNewDesignOnLabelPrinter2: event.target.value === 'new',
				useGapLabelOnLabelPrinter2: event.target.value === 'gap',
			});
	};
	const getDesignValue = (useGapLabel?: boolean, useNewDesign?: boolean) =>
		useGapLabel ? 'gap' : useNewDesign ? 'new' : 'old';
	const storeInfo = useAtomValue(StoreInfoState.curStoreInfo);
	const curDeviceInfo = StoreInfoState.useCurDeviceInfoForOrder();
	const 띠지프린터라벨출력 = PrintReceiptState.LabelPrinter.usePrintLabelPrinter({
		labelPrinterList: curDeviceInfo.labelPrinterList,
	});

	return (
		<Stack
			direction={'column'}
			flexGrow={1}>
			<SettingMenuItem
				title='라벨 프린터 1 디자인'
				innerElement={
					<FormControl>
						<FormLabel id='lp1-design'></FormLabel>
						<RadioGroup
							row
							name='lp1-design'
							defaultValue={getDesignValue(
								localSettings?.useGapLabelOnLabelPrinter1,
								localSettings?.useNewDesignOnLabelPrinter1
							)}
							onChange={selectLP1}>
							<FormControlLabel
								value='old'
								control={<Radio />}
								label='구형'
							/>
							<FormControlLabel
								value='new'
								control={<Radio />}
								label='신형'
							/>
							<FormControlLabel
								value='gap'
								control={<Radio />}
								label='라벨지 (50x80)'
							/>
						</RadioGroup>
					</FormControl>
				}
			/>
			<SettingMenuItem
				title='라벨 프린터 2 디자인'
				innerElement={
					<FormControl>
						<FormLabel id='lp2-design'></FormLabel>
						<RadioGroup
							row
							name='lp2-design'
							defaultValue={getDesignValue(
								localSettings?.useGapLabelOnLabelPrinter2,
								localSettings?.useNewDesignOnLabelPrinter2
							)}
							onChange={selectLP2}>
							<FormControlLabel
								value='old'
								control={<Radio />}
								label='구형'
							/>
							<FormControlLabel
								value='new'
								control={<Radio />}
								label='신형'
							/>
							<FormControlLabel
								value='gap'
								control={<Radio />}
								label='라벨지 (50x80)'
							/>
						</RadioGroup>
					</FormControl>
				}
			/>
			<SettingMenuItem
				title='라벨 프린터 명령'
				innerElement={
					<Box>
						<Select
							sx={{ marginRight: 2, height: 45 }}
							defaultValue='1'
							onChange={(e) => {
								setSelected(parseInt(e.target.value));
							}}>
							<MenuItem value='1'>라벨 프린터 1</MenuItem>
							<MenuItem value='2'>라벨 프린터 2</MenuItem>
						</Select>
						<Button
							variant='outlined'
							onClick={async () => {
								const designOptions = PrintReceiptState.LabelPrinter.getDesignOptions({
									localSettings,
									deviceNum: selected === 1 ? 'LabelPrinter1' : 'LabelPrinter2',
								});
								console.log(
									await 띠지프린터라벨출력({
										...LabelRequestDummy,
										deviceType: 'POS',
										deviceNum: selected === 1 ? 'LabelPrinter1' : 'LabelPrinter2',
										...designOptions,
										storeName: storeInfo.name,
										meta: designOptions.useGapLabel ? LabelRequestGapLabelMetaDummy : undefined,
										modelName:
											curDeviceInfo.labelPrinterList.find(
												(p) =>
													p.logicalName === (selected === 1 ? 'LabelPrinter1' : 'LabelPrinter2')
											)?.modelName ?? '',
									})
								);
							}}>
							샘플 라벨 출력
						</Button>
					</Box>
				}
			/>
			<SettingMenuItem
				title='기타 기능'
				innerElement={
					<Button
						sx={{ marginRight: 2 }}
						variant='outlined'
						disabled>
						프린터 상태
					</Button>
				}
			/>
		</Stack>
	);
};
